import { createFileRoute, redirect } from "@tanstack/react-router";
import type { ClientHomePlanBaseData } from "api-types/homePlans/homePlanResponses";
import Showroom from "lib/components/builders/communities/plans/showroom/Showroom";
import { getHomePlanBaseDataURL } from "lib/endpointHelpers";
import { useFetchNoAuth } from "lib/fetcher";
import { useAppRouterParams } from "lib/routeHelpers";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";

function PublicHomePlanOverviewPage() {
  const { builderId, homePlanId } = useAppRouterParams();

  const { data, loading } = useFetchNoAuth<ClientHomePlanBaseData>(
    builderId && homePlanId ? getHomePlanBaseDataURL({ builderId, homePlanId }) : "",
    [builderId, homePlanId],
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return (
    <>
      <Head>
        <title>{getPageTitle(data?.homePlan.planSetId)}</title>
        <meta name="robots" content="noindex" />
      </Head>
      {data && !loading && (
        <Showroom
          builder={data?.builder}
          location={data?.community}
          lot={data?.lot}
          masterPlan={data?.masterPlan}
          locationPlan={data?.communityPlan}
          homePlan={data?.homePlan}
          brochureSource={data?.brochureSource}
          lotDiscounts={data?.lotDiscounts}
          homePlanDiscounts={data?.homePlanDiscounts}
          overviewOnly
          publicConfig
          elevationOverrides={data?.elevationOverrides}
        />
      )}
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/home-plans/$home_plan_id/overview")({
  beforeLoad: ({ context, params }) => {
    if (!context.enabledFeatures.showroomUnification) {
      return;
    }
    throw redirect({
      to: "/showroom/plan/$home_plan_id/overview",
      params: { home_plan_id: params.home_plan_id },
      search: { builderId: params.builder_id },
      replace: true,
    });
  },
  component: PublicHomePlanOverviewPage,
});
